import React from 'react'
import { bool } from 'prop-types'

import { CheckoutConsumer } from 'contexts/Checkout'
import TinyCart from './TinyCart'

const Cart = ({ transparent }) => (
  <CheckoutConsumer>
    {({ checkout, checkoutUrl }) => {
      if (!checkout) return null

      const lineItems = checkout.lineItems?.edges
      const products = lineItems ? lineItems.map(product => product.node) : []

      const reducer = (a, b) => a + b
      const quantities = checkout.lineItems?.edges?.map(item => item.node.quantity)

      const quantity = quantities?.length ? quantities.reduce(reducer) : 0

      return (
        <TinyCart
          checkout={checkout}
          quantity={quantity}
          subtotal={checkout.subtotalPrice}
          products={products}
          checkoutUrl={checkoutUrl()}
          transparent={transparent}
        />
      )
    }}
  </CheckoutConsumer>
)

Cart.propTypes = {
  transparent: bool
}

export default Cart
